class UserSummaryController {
	private close:Function; //injected from modal-service
	
    public title: string;
    public accounts;
    
	// @ngInject
	constructor(
	){}
	
	public $onInit = () => {
		
	}
}
    

class UserSummaryModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    accounts: "<",
	    close:'='
	};

	public controller = UserSummaryController;
	public controllerAs = 'userSummary';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/usersummary-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { UserSummaryModal };
